export default "__VITE_ASSET__09348a6e__"